import { useInterval, useBoolean } from 'react-use';

import { getIfInMeeting } from '@store/meeting/meeting.slice';
import { getVoovLoginState, VoovLoginStateEnum } from '@store/authentication/authentication.slice';

import { useAppSelector } from '@store/hooks';

/**
 * 等待账号登录成功，自动进会
 */
export default function useAutoJoin(joinMeetingAutomatically?: Function) {
  const voovLoginState = useAppSelector(getVoovLoginState);
  const inMeeting = useAppSelector(getIfInMeeting);

  const [isWaitingVoovLogin, toggleIsWaitingVoovLogin] = useBoolean(true);


  useInterval(
    async () => {
      if (voovLoginState === VoovLoginStateEnum.succeeded && !inMeeting) {
        toggleIsWaitingVoovLogin();

        typeof joinMeetingAutomatically === 'function' && joinMeetingAutomatically();
      }
    },
    isWaitingVoovLogin ? 20 : null,
  );

}
